<template>
  <!-- 隐患数据列表 -->
  <div class="page_box">
    
    <div class="page_option_box">
      <transition name="el-zoom-in-center">
        <div class="option_box" style="width:30%" v-if="!searchIsUnfold">
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-top-right"
            @click="exportReport"
            :disabled="responseData.list.length == 0"
            >导出</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-circle-plus-outline"
            @click="openReportHiddenDangerBox()"
            >上报隐患</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-map-location"
            @click="$Common.pageJump('/hidden_danger_preset_location', 3)"
            >预设地点</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-film"
            @click="$Common.pageJump('/hidden_danger_classification', 3)"
            >分类管理</el-button
          >
      </div>
      </transition>
      
      <div class="search_box" :style="searchIsUnfold ? 'width:100%':'width:70%'">
        <i :class="!searchIsUnfold ? 'el-icon-arrow-left arrow-left':'el-icon-arrow-right arrow-left'" @click="stateAlter"></i>
        <el-select
        v-if="searchIsUnfold"
            v-model="requestData.hiddenDangerClass"
            clearable
            placeholder="请选择隐患等级"
            size="mini"
          >
            <el-option label="一般隐患" :value="1"> </el-option>
            <el-option label="重大隐患" :value="3"> </el-option>
          </el-select>
          <el-select
        v-if="searchIsUnfold"
            v-model="requestData.hiddenDangerFrom"
            clearable
            placeholder="请选择隐患来源"
            size="mini"
          >
            <el-option
              v-for="item in $store.state.select.hiddenDangerSource"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
        v-if="searchIsUnfold"
            v-model="requestData.hiddenDangerStatus"
            clearable
            placeholder="请选择隐患状态"
            size="mini"
          >
            <el-option
              v-for="item in $store.state.select.hiddenDangerStatus"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input
        v-if="searchIsUnfold"
            size="mini"
            clearable
            placeholder="上报人姓名"
            class="textInput"
            v-model.trim="requestData.reportUserName"
          ></el-input
          >
          <el-input
        v-if="searchIsUnfold"
            size="mini"
            clearable
            placeholder="处理人姓名"
            class="textInput"
            v-model.trim="requestData.disposeUserName"
          ></el-input
          >
          <el-input
            size="mini"
            clearable
            placeholder="请输入隐患编码"
            class="textInput"
            v-model.trim="requestData.hiddenDangerNumber"
          ></el-input
          >
          <el-button
            size="mini"
            type="primary"
            plain
            icon="el-icon-search"
            @click="searchHiddenDangerData"
            >搜索</el-button
          >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column prop="hiddenDangerNumber" label="隐患编码" align="center">
          </el-table-column>
          <el-table-column
            prop="hiddenDangerImgUrl"
            label="隐患图片"
            width="82" align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width:60px;height:60px"
                v-if="scope.row.hiddenDangerImgUrl"
                :src="
                  $store.state.config.fileUrl + scope.row.hiddenDangerImgUrl
                "
                :preview-src-list="[
                  $store.state.config.fileUrl + scope.row.hiddenDangerImgUrl
                ]"
              >
              </el-image>
              <el-image
                style="width:60px;height:60px"
                v-if="!scope.row.hiddenDangerImgUrl"
                :src="require('@/assets/img/noData/no_img.png')"
                :preview-src-list="[require('@/assets/img/noData/no_img.png')]"
              >
              </el-image>
            </template>
          </el-table-column>

          <el-table-column
            prop="hiddenDangerImgAfterurl"
            label="整改图片"
            width="82" align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width:60px;height:60px"
                v-if="scope.row.hiddenDangerImgAfterurl"
                :src="
                  $store.state.config.fileUrl +
                    scope.row.hiddenDangerImgAfterurl
                "
                :preview-src-list="[
                  $store.state.config.fileUrl +
                    scope.row.hiddenDangerImgAfterurl
                ]"
              >
              </el-image>
              <el-image
                style="width:60px;height:60px"
                v-if="!scope.row.hiddenDangerImgAfterurl"
                :src="require('@/assets/img/noData/no_img.png')"
                :preview-src-list="[require('@/assets/img/noData/no_img.png')]"
              >
              </el-image>
            </template>
          </el-table-column>

          <el-table-column prop="hiddenDangerClass" label="隐患等级" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.hiddenDangerClass == 1">一般隐患</span>
              <span v-if="scope.row.hiddenDangerClass == 3" style="color: red;"
                >重大隐患</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="hiddenDangerFrom" label="隐患来源" align="center">
            <template slot-scope="scope">
              {{
                $store.state.select.hiddenDangerSource[
                  scope.row.hiddenDangerFrom
                ].nameOne
              }}
            </template>
          </el-table-column>

          <el-table-column prop="hiddenDangerDescribe" label="隐患描述" align="center">
          </el-table-column>

          <el-table-column prop="hiddenDangerClassifyName" label="类别" align="center">
            <template slot-scope="scope">
              <span v-show="!scope.row.hiddenDangerClassifyName">未指定</span>
              <span v-show="scope.row.hiddenDangerClassifyName">{{
                scope.row.hiddenDangerClassifyName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reportUserName" label="报告人" align="center">
          </el-table-column>

          <el-table-column prop="disposeUserName" label="处理人" align="center">
          </el-table-column>

          <el-table-column
            prop="LastOperatingTime"
            label="上报时间" align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.LastOperatingTime) }}
            </template>
          </el-table-column>

          <el-table-column prop="hiddenDangerStatus" label="状态" align="center">
            <template slot-scope="scope">
              {{
                $store.state.select.hiddenDangerStatus[
                  scope.row.hiddenDangerStatus
                ].nameTwo
              }}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                  @click="seeHazardDetails(scope.row.id)"
                :underline="false"
                >详情</el-link
              >
              <el-divider direction="vertical" v-if="
                  scope.row.hiddenDangerStatus == 0 &&
                    scope.row.principalId == $store.getters.getUserInfo.userId
                "></el-divider>
              <el-link v-if="
                  scope.row.hiddenDangerStatus == 0 &&
                    scope.row.principalId == $store.getters.getUserInfo.userId
                "
                class="link_box"
                type="primary"
                  @click="editHazardDetails(scope.row, 1)"
                :underline="false"
                >指派</el-link
              >
              <el-divider direction="vertical" v-if="
                  scope.row.hiddenDangerStatus == 1 &&
                    scope.row.disposeUserId == $store.getters.getUserInfo.userId
                "></el-divider>
              <el-link v-if="
                  scope.row.hiddenDangerStatus == 1 &&
                    scope.row.disposeUserId == $store.getters.getUserInfo.userId
                "
                class="link_box"
                type="primary"
                  @click="editHazardDetails(scope.row, 2)"
                :underline="false"
                >处理</el-link
              >
              <el-divider direction="vertical" v-if="
                  scope.row.hiddenDangerStatus == 1 &&
                    scope.row.redeployStatus == 1 &&
                    scope.row.disposeUserId == $store.getters.getUserInfo.userId
                "></el-divider>
              <el-link v-if="
                  scope.row.hiddenDangerStatus == 1 &&
                    scope.row.redeployStatus == 1 &&
                    scope.row.disposeUserId == $store.getters.getUserInfo.userId
                "
                class="link_box"
                type="primary"
                  @click="editHazardDetails(scope.row, 3)"
                :underline="false"
                >转派</el-link
              >
              <el-divider direction="vertical" v-if="
                  scope.row.hiddenDangerStatus == 2 &&
                    scope.row.principalId == $store.getters.getUserInfo.userId
                "></el-divider>
              <el-link v-if="
                  scope.row.hiddenDangerStatus == 2 &&
                    scope.row.principalId == $store.getters.getUserInfo.userId
                "
                class="link_box"
                type="primary"
                  @click="editHazardDetails(scope.row, 4)"
                :underline="false"
                >验收</el-link
              >
              <el-divider direction="vertical" v-if="
                  scope.row.hiddenDangerStatus < 3 &&
                    (scope.row.reportUserId ==
                      $store.getters.getUserInfo.userId ||
                      scope.row.principalId ==
                        $store.getters.getUserInfo.userId)
                "></el-divider>
              <el-link
              v-if="
                  scope.row.hiddenDangerStatus < 3 &&
                    (scope.row.reportUserId ==
                      $store.getters.getUserInfo.userId ||
                      scope.row.principalId ==
                        $store.getters.getUserInfo.userId)
                "
                class="link_box"
                type="primary"
                  @click="openRevokeBox(scope.row)"
                :underline="false"
                >撤销</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        class="pagination_box"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
      <!-- 上报隐患 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog"
        :destroy-on-close="true"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        title="上报隐患"
        size="40%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患位置</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="insertData.hiddenDangerPosition"
                  placeholder="隐患位置"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">负责人</label>
              <div class="col-sm-10">
                <template>
                  <el-select
                    style="width:100%"
                    size="small"
                    v-model="temporaryData.personId"
                    @change="selectPerson()"
                    placeholder="请选择"
                  >
                    <el-option label="请选择" :value="0"></el-option>
                    <el-option
                      v-for="(value, index) in personList"
                      :key="index"
                      :value="value.userId"
                      :disabled="value.disabled"
                      :label="value.userName"
                    ></el-option>
                  </el-select>
                </template>
              </div>
            </div>
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"
                >隐患图片
              </label>
              <div class="col-sm-10">
                <head-portrait-up-load
                  :imageUrl="insertData.hiddenDangerImgUrl"
                  @imageChange="imageChange"
                ></head-portrait-up-load>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患描述</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="insertData.hiddenDangerDescribe"
                ></textarea>
              </div>
            </div>
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button
                  size="mini"
                  type="primary"
                  @click="reportHiddenDanger"
                  >确定上报</el-button
                >
                <el-button size="mini" @click="dialog = false">返回</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>

      <!-- 指派  /  处理  / 转派-->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="detailsDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        size="40%"
        
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患编码</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.hiddenDangerNumber"
                  disabled
                  placeholder="隐患编码"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患位置</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.hiddenDangerPosition"
                  disabled
                  placeholder="隐患位置"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患描述</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  rows="3"
                  disabled
                  v-model="detailsData.hiddenDangerDescribe"
                ></textarea>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患图片</label>
              <div class="col-sm-10">
                <el-image
                  v-if="detailsData.hiddenDangerImgUrl"
                  style="width: 100px; height: 100px"
                  :src="
                    $store.state.config.fileUrl + detailsData.hiddenDangerImgUrl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl + detailsData.hiddenDangerImgUrl
                  ]"
                >
                </el-image>
                <span v-show="!detailsData.hiddenDangerImgUrl">
                  暂无隐患图片
                </span>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">上报时间</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.addTime"
                  disabled
                  placeholder="上报时间"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">上报人</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.reportUserName"
                  disabled
                  placeholder="上报人"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患类型</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  :disabled="detailsData.hiddenDangerStatus < 1 ? false : true"
                  v-model="detailsData.hiddenDangerClassifyName"
                  @change="selectPerson()"
                >
                  <option value="0">请选择</option>
                  <option
                    v-for="value in hiddenDangerType"
                    :key="value.hiddenDangerId"
                    :value="value.hiddenDangerId"
                  >
                    {{
                      value.hiddenDangerClassifyOperation == 0
                        ? "【系统】" + value.hiddenDangerClassifyName
                        : "【自定义】" + value.hiddenDangerClassifyName
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group" v-if="isAssign == 1">
              <label class="col-sm-2 control-label">隐患等级</label>
              <div class="col-sm-10">
                <el-select
                  style="width:100%"
                  v-model="detailsData.hiddenDangerClass"
                  placeholder="请选择隐患等级"
                  size="small"
                >
                  <el-option label="一般隐患" :value="1"> </el-option>
                  <el-option label="重大隐患" :value="3"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group" v-if="isAssign == 1">
              <label class="col-sm-2 control-label">处理人</label>
              <div class="col-sm-10">
                <template>
                  <el-select
                    size="small"
                    style="width:100%"
                    :disabled="
                      detailsData.hiddenDangerStatus < 1 ||
                      detailsData.redeployStatus == 1
                        ? false
                        : true
                    "
                    v-model.number="detailsData.disposeUserId"
                    placeholder="请选择"
                    @change="selectHandler()"
                  >
                    <el-option label="请选择" :value="0"></el-option>
                    <el-option
                      v-for="(item, index) in processorsList"
                      :key="index"
                      :label="item.userName"
                      :value="item.userId"
                      :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </template>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">要求处理完成时间</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  v-model="detailsData.completionTime"
                  :disabled="detailsData.hiddenDangerStatus < 1 ? false : true"
                >
                  <option value="0">请选择</option>
                  <option v-for="value in hourList" :key="value" :value="value">
                    {{ value }}小时
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <!-- <div class="form-group" v-show="detailsData.hiddenDangerStatus==0"> -->
              <label class="col-sm-2 control-label">是否允许转派</label>
              <div class="col-sm-10">
                <el-radio-group
                  v-model="detailsData.redeployStatus"
                  size="small"
                  :disabled="detailsData.hiddenDangerStatus == 0 ? false : true"
                >
                  <el-radio :label="0" border>不允许转派</el-radio>
                  <el-radio :label="1" border>允许转派</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">
                <!-- {{$store.getters.getUserInfo.userId}} -- {{detailsData.disposeUserName}} -->
                处理流水记录
              </label>
              <div class="col-sm-10">
                <div
                  class="flowing_water_list"
                  v-for="value in detailsData.newFlowDataList"
                  :key="value.id"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="value.str"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div v-show="detailsData.hiddenDangerStatus >= 1">
              <!-- 处理人等于当前登录用户 -->
              <div
                v-show="
                  $store.getters.getUserInfo.userId == detailsData.disposeUserId
                "
              >
                <div class="form-group">
                  <label class="col-sm-2 control-label">整改图片 </label>
                  <div class="col-sm-10">
                    <head-portrait-up-load
                      :imageUrl="hiddenDangerHandleData.hiddenDangerImgAfterurl"
                      @imageChange="imageHandleChange"
                    ></head-portrait-up-load>
                    <!-- <label for="img_file">
                      <input
                        type="file"
                        id="img_file"
                        @change="imgUploadRectification($event)"
                      />
                      <span class="btn btn-info btn-sm">
                        <i class="el-icon-circle-plus"></i>
                        添加文件
                      </span>
                    </label> -->
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-if="
                  detailsData.hiddenDangerImgAfterurl != '' &&
                    detailsData.hiddenDangerStatus > 1
                "
              >
                <div class="col-sm-offset-2 col-sm-10">
                  <div>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="
                        $store.state.config.fileUrl +
                          detailsData.hiddenDangerImgAfterurl
                      "
                      :preview-src-list="[
                        $store.state.config.fileUrl +
                          detailsData.hiddenDangerImgAfterurl
                      ]"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <div v-show="detailsData.hiddenDangerStatus == 1">
                <div class="form-group">
                  <label class="col-sm-2 control-label">整改备注</label>
                  <div class="col-sm-10">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="remarks"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                v-show="
                  $store.getters.getUserInfo.userId ==
                    detailsData.principalId &&
                    detailsData.hiddenDangerStatus == 2
                "
              >
                <div class="form-group">
                  <label class="col-sm-2 control-label">验收状态</label>
                  <div class="col-sm-10">
                    <el-radio-group
                      v-model="hiddenDangerInspectData.waterStatus"
                      size="small"
                    >
                      <el-radio :label="0" border>验收通过</el-radio>
                      <el-radio :label="1" border>验收不通过</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <div
                v-show="
                  $store.getters.getUserInfo.userId ==
                    detailsData.principalId &&
                    detailsData.hiddenDangerStatus == 2
                "
              >
                <div class="form-group">
                  <label class="col-sm-2 control-label">验收备注</label>
                  <div class="col-sm-10">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="hiddenDangerInspectData.runningWaterRemark"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button
                  size="mini"
                  v-if="detailsData.hiddenDangerStatus == 0"
                  type="primary"
                  @click="hiddenDangerAssign"
                  >确定指派</el-button
                >
                <el-button
                  size="mini"
                  v-if="detailsData.hiddenDangerStatus == 1 && isRedeploy == 1"
                  type="primary"
                  @click="hiddenDangerTransfer"
                  >确定转派</el-button
                >
                <el-button
                  size="mini"
                  v-if="detailsData.hiddenDangerStatus == 1 && isRedeploy == 0"
                  type="primary"
                  @click="hiddenDangerHandle"
                  >确定处理</el-button
                >
                <el-button
                  size="mini"
                  v-if="
                    detailsData.hiddenDangerStatus == 2 &&
                      $store.getters.getUserInfo.userId ==
                        detailsData.principalId
                  "
                  type="primary"
                  @click="hiddenDangerInspect"
                  >隐患验收</el-button
                >
                <el-button size="mini" @click="detailsDialog = false"
                  >返回</el-button
                >
              </div>
            </div>
          </form>
        </div>
      </el-dialog>

      <!-- 查看隐患-->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="seeDetailsDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        title="查看隐患"
         width="800px"
        size="40%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患编码</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.hiddenDangerNumber"
                  disabled
                  placeholder="隐患编码"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患位置</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.hiddenDangerPosition"
                  disabled
                  placeholder="隐患位置"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患描述</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  rows="3"
                  disabled
                  v-model="detailsData.hiddenDangerDescribe"
                ></textarea>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">隐患图片</label>
              <div class="col-sm-10">
                <el-image
                  v-if="detailsData.hiddenDangerImgUrl"
                  style="width: 100px; height: 100px"
                  :src="
                    $store.state.config.fileUrl + detailsData.hiddenDangerImgUrl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl + detailsData.hiddenDangerImgUrl
                  ]"
                >
                </el-image>
                <span v-if="!detailsData.hiddenDangerImgUrl">
                  暂无隐患图片
                </span>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">上报时间</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.addTime"
                  disabled
                  placeholder="上报时间"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">上报人</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="detailsData.reportUserName"
                  disabled
                  placeholder="上报人"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">隐患类型</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  disabled
                  v-model="detailsData.hiddenDangerClassifyName"
                >
                  <option :value="0">未指定</option>
                  <option
                    v-for="value in hiddenDangerType"
                    :key="value.hiddenDangerId"
                    :value="value.hiddenDangerId"
                  >
                    {{
                      value.hiddenDangerClassifyOperation == 0
                        ? "【系统】" + value.hiddenDangerClassifyName
                        : value.hiddenDangerClassifyName
                    }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">处理人</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  disabled
                  v-model="detailsData.disposeUserId"
                >
                  <option :value="detailsData.disposeUserId">{{
                    detailsData.disposeUserName
                  }}</option>
                  <!-- <option
										v-for="value in processorsList"
										:key="value.userId"
										:value="value.userId"
									>
										{{ value.userName }}
									</option> -->
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">要求处理完成时间</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  disabled
                  v-model="detailsData.completionTime"
                >
                  <option value="0">未选择</option>
                  <option v-for="value in hourList" :key="value" :value="value">
                    {{ value }}小时
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">是否允许转派</label>
              <div class="col-sm-10">
                <el-radio-group
                  v-model="detailsData.redeployStatus"
                  size="small"
                  disabled
                >
                  <el-radio :label="0" border>不允许转派</el-radio>
                  <el-radio :label="1" border>允许转派</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">
                处理流水记录
              </label>
              <div class="col-sm-10">
                <div
                  class="flowing_water_list"
                  v-for="value in detailsData.newFlowDataList"
                  :key="value.id"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="value.str"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div
              v-show="
                detailsData.hiddenDangerStatus == 2 ||
                  detailsData.hiddenDangerStatus == 4
              "
            >
              <div
                class="form-group"
                v-if="detailsData.hiddenDangerImgAfterurl"
              >
                <div class="col-sm-offset-2 col-sm-10">
                  <div>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="
                        $store.state.config.fileUrl +
                          detailsData.hiddenDangerImgAfterurl
                      "
                      :preview-src-list="[
                        $store.state.config.fileUrl +
                          detailsData.hiddenDangerImgAfterurl
                      ]"
                    >
                    </el-image>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">整改备注</label>
                <div class="col-sm-10">
                  <textarea
                    class="form-control"
                    rows="3"
                    disabled
                    v-model="hiddenDangerHandleData.runningWaterRemark"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button size="mini" @click="seeDetailsDialog = false"
                  >返回</el-button
                >
              </div>
            </div>
          </form>
        </div>
      </el-dialog>

      <!-- 撤销 -->
      <el-dialog
        title="请填上你的撤销理由，并确定"
        :visible.sync="centerDialogVisible"
        width="40%"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="resubmit_content_box">
          <div class="resubmit_form ">
            <textarea
              class="form-control"
              rows="3"
              v-model="revokeData.runningWaterRemark"
            ></textarea>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitHiddenDangerRevoke"
            >确定撤销</el-button
          >

          <el-button @click="centerDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "HiddenDangerData",
  components: {
    HeadPortraitUpLoad
  },
  props: {},
  data() {
    return {
      seeDetailsDialog: false,
      hourList: 72,
      dialog: false,
      detailsDialog: false,
      centerDialogVisible: false,
      requestData: {
        schoolId: parseInt(this.$store.state.schoolId), // 学校id
        reportUserName: "", // 上报人
        disposeUserName: "", // 处理人
        hiddenDangerClass: "", // 隐患等级
        hiddenDangerFrom: "", // 隐患来源
        hiddenDangerStatus: "", // 隐患状态
        hiddenDangerNumber: "", // 隐患编码
        pageNum: 1,
        pageSize: 20
      },
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },

      insertData: {
        hiddenDangerImgUrl: "",
        hiddenDangerDescribe: "",
        reportUserName:
          this.$store.getters.getUserInfo.userName +
          "_" +
          this.$store.getters.getUserInfo.userId,
        hiddenDangerPosition: "",
        principalName: "",
        schoolId: this.$store.state.schoolId
      },
      // 临时数据
      temporaryData: {
        personName: "", // 负责人姓名
        personId: "" // 负责人ID
      },

      // 负责人列表
      personList: [],
      // 处理人列表
      processorsList: [],
      isPersonData: false,
      detailsData: {},
      // 撤销数据
      revokeData: {
        Id: "",
        runningWaterDestName: this.$store.getters.getUserInfo.userName, // 撤销该隐患的人的名称
        runningWaterStatus: 5, // 流水状态 流水记录状态0.上报给 1.已指派给2.已处理3.重新指派给4.已验收5.已撤销该隐患
        runningWaterRemark: "" // 传入撤销的原因
      },
      // 隐患类型
      hiddenDangerType: [],

      // 隐患指派数据
      hiddenDangerAssignData: {
        runningWaterObjectName: this.$store.getters.getUserInfo.userName,
        id: "",
        hiddenDangerClassifyId: "",
        disposeUserName: "",
        completionTime: 0,
        redeployStatus: 0,
        hiddenDangerClass: ""
      },
      // 隐患详情状态 1指派，2转派处理/
      // detailsDataState: 1,
      isAssign: false, //是否为指派
      isRedeploy: 0, // 选择转派或处理 0处理，1转派

      // 转派和处理时临时备注
      remarks: "",
      // 隐患转派数据
      hiddenDangerTransferData: {
        // runningWaterObjectName:this.$store.getters.getUserInfo.userName,

        hiddenId: "",
        whetherToTransfer: "",
        transferee: this.$store.getters.getUserInfo.userName,
        transferNotes: ""
      },

      // 隐患处理数据
      hiddenDangerHandleData: {
        id: "",
        hiddenDangerImgAfterurl: "",
        runningWaterDestName: this.$store.getters.getUserInfo.userName,
        runningWaterRemark: ""
      },

      // 隐患验收数据
      hiddenDangerInspectData: {
        id: "",
        runningWaterDestName: this.$store.getters.getUserInfo.userName,
        runningWaterRemark: "",
        waterStatus: 0
      },
      showUpHidden: false,
      searchIsUnfold:false,//查询条件是否展开
    };
  },
  watch: {},
  methods: {
    imgTest() {
      // console.log(222);
    },
    imageChange(src) {
      this.insertData.hiddenDangerImgUrl = src || "";
    },
    imageHandleChange(src) {
      this.hiddenDangerHandleData.hiddenDangerImgAfterurl = src || "";
    },
    // 编辑隐患详情
    async editHazardDetails(info, num) {
      if (num == 0 || num == 1 || num == 3) {
        this.isAssign = true;
      } else {
        this.isAssign = false;
      }
      if (num == 3) {
        this.isRedeploy = 1;
      } else {
        this.isRedeploy = 0;
      }

      let getHazardDetails = await this.getHazardDetails(info.id);

      this.detailsDialog = true;
      // console.log(getHazardDetails)
      // if(getHazardDetails == true){
      //     if(this.detailsData.disposeUserId == this.$store.getters.getUserInfo.userId){
      //     } else {
      //         this.$message('你不是处理人，没有权限进行此操作！');
      //     }
      // }
    },

    // 查看
    async seeHazardDetails(id) {
      let getHazardDetails = await this.getHazardDetails(id);
      if (getHazardDetails == true) {
        this.seeDetailsDialog = true;
      }
    },

    // 获取隐患详情
    async getHazardDetails(id) {
      var paramData = {
        id: id
      };

      let res = await this.$Http.hazardDetails(paramData);
      // console.log(res);
      if (res.code == 200) {
        this.hiddenDangerAssignData.id = id; // 指派数据ID
        this.hiddenDangerTransferData.hiddenId = id; // 转派数据ID
        this.hiddenDangerHandleData.id = id; // 处理数据ID

        this.detailsData = res.data;
        this.detailsData.disposeUserName = res.data.disposeUserName;
        this.detailsData.runningWaterObjectName = parseInt(
          res.data.runningWaterObjectName
        );
        this.detailsData.addTime = this.$Common.dateFormatDateTwo(
          res.data.addTime
        );
        // console.log(this.detailsData.runningWater)
        var flowData = this.detailsData.runningWater;
        var newFlowData = [];
        for (var value in flowData) {
          if (flowData[value].runningWaterObjectName != "") {
            var flowDataString =
              this.$Common.dateFormatDateTwo(flowData[value].runningWaterTime) +
              "  " +
              (flowData[value].runningWaterObjectName !== null
                ? flowData[value].runningWaterObjectName
                : "") +
              "  " +
              this.$store.state.select.flowState[
                flowData[value].runningWaterStatus
              ].nameOne +
              "  " +
              (flowData[value].runningWaterDestName !== null
                ? flowData[value].runningWaterDestName
                : "") +
              "  " +
              (flowData[value].runningWaterRemark
                ? "备注：" + flowData[value].runningWaterRemark
                : "");
          } else {
            var flowDataString =
              this.$Common.dateFormatDateTwo(flowData[value].runningWaterTime) +
              "  " +
              // (flowData[value].runningWaterObjectName !== null
              //   ? flowData[value].runningWaterObjectName
              //   : "") +
              (flowData[value].runningWaterDestName !== null
                ? flowData[value].runningWaterDestName
                : "") +
              "  " +
              this.$store.state.select.flowState[
                flowData[value].runningWaterStatus
              ].nameOne +
              "  " +
              (flowData[value].runningWaterRemark
                ? "备注：" + flowData[value].runningWaterRemark
                : "");
          }

          var flowDataObj = {
            id: flowData[value].runningWaterTime,
            str: flowDataString
          };
          newFlowData.push(flowDataObj);
        }
        this.detailsData.newFlowDataList = newFlowData;
        // console.log(this.detailsData);
        this.getAllHiddenDangerType();
        // 判断是否为高校院系
        if (this.$store.getters.getUserInfo.eduBuresuType == -1) {
          if (
            this.$store.getters.getUserInfo.logisticsId == 0 ||
            this.$store.getters.getUserInfo.logisticsId == "" ||
            !this.$store.getters.getUserInfo.logisticsId
          ) {
            this.getPersonList();
            this.getProcessorsList();
          } else {
            this.getPersonListLogistics();
            this.getProcessorsListLogistics();
          }
        } else {
          this.getPersonList();
          this.getProcessorsList();
        }
        return true;
        // this.detailsDialog = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }

      return false;
    },

    // 隐患指派
    async hiddenDangerAssign() {
      if (this.detailsData.hiddenDangerClassifyName == 0) {
        this.$message("请选择隐患类型！");
        return;
      }
      if (this.detailsData.hiddenDangerClass == 0) {
        this.$message("请选择隐患等级！");
        return;
      }
      if (this.detailsData.disposeUserId == 0) {
        this.$message("请选择处理人！");
        return;
      }
      if (this.detailsData.completionTime == 0) {
        this.$message("请选择隐患处理完成时间！");
        return;
      }
      this.hiddenDangerAssignData.hiddenDangerClassifyId = this.detailsData.hiddenDangerClassifyName;
      this.hiddenDangerAssignData.completionTime = this.detailsData.completionTime;
      this.hiddenDangerAssignData.redeployStatus = this.detailsData.redeployStatus;
      this.hiddenDangerAssignData.hiddenDangerClass = this.detailsData.hiddenDangerClass;
      // this.hiddenDangerAssignData.disposeUserName = element.userName+'_'+element.userId
      // this.hiddenDangerAssignData.disposeUserName = this.detailsData.disposeUserName
      var newData = this.hiddenDangerAssignData;
      // console.log(newData)
      // return false
      let res = await this.$Http.hiddenDangerAssign(newData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "指派成功"
        });
        this.cancelForm();
        this.gethiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(this.hiddenDangerAssignData)
    },

    // 隐患转派
    async hiddenDangerTransfer() {
      if (this.hiddenDangerTransferData.whetherToTransfer == "") {
        this.hiddenDangerTransferData.whetherToTransfer =
          this.detailsData.disposeUserName +
          "_" +
          this.detailsData.disposeUserId;
      }
      if (this.hiddenDangerTransferData.disposeUserName == "") {
        this.hiddenDangerTransferData.disposeUserName = this.detailsData.psDisposeUserName;
      }
      this.hiddenDangerTransferData.transferNotes = this.remarks;
      var newData = this.hiddenDangerTransferData;

      let res = await this.$Http.hiddenDangerTransfer(newData, true);
      if (res.code == 200) {
        this.hiddenDangerTransferData.transferNotes = "";
        this.$message({
          type: "success",
          message: "转派成功"
        });
        this.cancelForm();
        this.gethiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(this.hiddenDangerAssignData)
    },

    // 隐患处理
    async hiddenDangerHandle() {
      // this.hiddenDangerHandleData.runningWaterRemark = this.detailsData.runningWaterRemark
      // this.hiddenDangerAssignData.completionTime = this.detailsData.completionTime
      // this.hiddenDangerAssignData.redeployStatus = this.detailsData.redeployStatus
      this.hiddenDangerHandleData.runningWaterRemark = this.remarks;
      var newData = this.hiddenDangerHandleData;

      let res = await this.$Http.hiddenDangerHandle(newData, true);
      if (res.code == 200) {
        this.hiddenDangerHandleData.runningWaterRemark = "";
        this.$message({
          type: "success",
          message: "处理成功"
        });
        this.cancelForm();
        this.gethiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(this.hiddenDangerAssignData)
    },

    // 隐患验收
    async hiddenDangerInspect() {
      this.hiddenDangerInspectData.id = this.detailsData.id;
      // this.hiddenDangerAssignData.completionTime = this.detailsData.completionTime
      // this.hiddenDangerAssignData.redeployStatus = this.detailsData.redeployStatus
      var newData = this.hiddenDangerInspectData;

      let res = await this.$Http.hiddenDangerInspect(newData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "隐患已验收"
        });
        this.cancelForm();
        this.gethiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(this.hiddenDangerAssignData)
    },

    // 打开撤销窗口
    openRevokeBox(info) {
      // if (info.reportUserId != this.$store.getters.getUserInfo.userId) {
      //   this.$message("你不是上报人或负责人，没有权限进行此操作！");
      // } else {
      //   this.revokeData.Id = info.id;
      //   this.centerDialogVisible = true;
      // }
      this.revokeData.Id = info.id;
      this.centerDialogVisible = true;
    },

    // 提交撤销信息
    async submitHiddenDangerRevoke() {
      // var newData = this.insertData

      let res = await this.$Http.submitHiddenDangerRevoke(
        this.revokeData,
        true
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "撤销成功"
        });
        this.centerDialogVisible = false;
        this.gethiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 选择负责人
    selectPerson() {
      this.personList.forEach((element) => {
        if (element.userId == this.temporaryData.personId) {
          this.temporaryData.personName = element.userName;
          this.temporaryData.personId = element.userId;

          this.insertData.principalName =
            element.userName + "_" + element.userId;
          this.hiddenDangerAssignData.disposeUserName =
            element.userName + "_" + element.userId;
          // console.log(this.hiddenDangerAssignData);
          return false;
        }
      });
    },

    // 选择处理人
    selectHandler(id) {
      this.processorsList.forEach((element) => {
        if (element.userId == this.detailsData.disposeUserId) {
          this.hiddenDangerAssignData.disposeUserName =
            element.userName + "_" + element.userId;
          this.hiddenDangerTransferData.whetherToTransfer =
            element.userName + "_" + element.userId;
          // console.log(this.hiddenDangerAssignData.disposeUserName)
          // console.log(this.hiddenDangerTransferData)
          return false;
        }
      });
    },
    // 获取隐患数据
    async gethiddenDangerData() {
      // console.log(this.requestData);
      let res = await this.$Http.getHiddenDangerList(this.requestData, true);
      // console.log(res)
      if (res.code == 200) {
        if (res.data) {
          this.responseData = res.data;
        } else {
          this.responseData.pageSize = 0;
          this.responseData.pageNum = 0;
          this.responseData.total = 0;
          this.responseData.pages = 0;
          this.responseData.list = [];
        }
      } else if (res.code == 101) {
        this.responseData.pageSize = 0;
        this.responseData.pageNum = 0;
        this.responseData.total = 0;
        this.responseData.pages = 0;
        this.responseData.list = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取隐患类型
    async getAllHiddenDangerType() {
      var paramData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getAllHiddenDangerType(paramData, true);
      // console.log(res)
      if (res.code == 200) {
        this.hiddenDangerType = res.data;
        // console.log(this.hiddenDangerType)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 图片上传
    async imgUpload(event) {
      var uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        this.insertData.hiddenDangerImgUrl = uploadInfo.fileUrl;
        // console.log(this.insertData.hiddenDangerImgUrl);
      }
      this.$refs.img_file.value = "";
    },

    // 上穿整改图片传
    async imgUploadRectification(event) {
      var uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        this.detailsData.hiddenDangerImgAfterurl = uploadInfo.fileUrl;
        this.hiddenDangerHandleData.hiddenDangerImgAfterurl =
          uploadInfo.fileUrl;

        // console.log(this.hiddenDangerHandleData.hiddenDangerImgAfterurl);
      }
    },
    // 隐患搜索
    searchHiddenDangerData() {
      this.requestData.pageNum = 1;
      this.gethiddenDangerData();
    },
    cancelForm() {
      // this.loading = false;
      this.dialog = false;
      (this.detailsDialog = false), (this.seeDetailsDialog = false);
      clearTimeout(this.timer);
    },

    // 打开上报隐患窗口
    async openReportHiddenDangerBox() {
      // let isMember = await this.whetherMember();
      // if ( isMember ) {
      this.insertData.hiddenDangerPosition = "";
      this.insertData.hiddenDangerImgUrl = "";
      this.insertData.hiddenDangerDescribe = "";
      // 判断是否为高校院系
      if (this.$store.getters.getUserInfo.eduBuresuType == -1) {
        if (
          this.$store.getters.getUserInfo.logisticsId == 0 ||
          this.$store.getters.getUserInfo.logisticsId == "" ||
          !this.$store.getters.getUserInfo.logisticsId
        ) {
          this.getPersonList();
          this.getProcessorsList();
        } else {
          this.getPersonListLogistics();
          this.getProcessorsListLogistics();
        }
      } else {
        this.getPersonList();
        this.getProcessorsList();
      }

      this.dialog = true;
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "您当前不是组员，无法上报隐患！"
      //   });
      // }
    },

    // 获取隐患 负责人
    async getPersonList() {
      var requestData = {
        schoolId: this.$store.state.schoolId,
        type: 0
      };
      let res = await this.$Http.getPersonList(requestData);
      if (res.code == 200) {
        let persionList = res.data;
        for (var i = 0; i < persionList.length; i++) {
          if (persionList[i].userId == this.$store.getters.getUserInfo.userId) {
            persionList[i].disabled = true;
          }
        }
        this.personList = persionList;
        if (this.personList.length >= 1) {
          this.isPersonData = true;
          return false;
        }
        this.$message({
          type: "error",
          message: "暂无负责人数据"
        });
      } else if (res.code == 101) {
        this.personList = [];
      } else {
        this.personList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取隐患 处理人
    async getProcessorsList() {
      var requestData = {
        schoolId: this.$store.state.schoolId,
        type: 0
      };
      let res = await this.$Http.getProcessorsList(requestData);
      if (res.code == 200) {
        let persionList = res.data;
        for (var i = 0; i < persionList.length; i++) {
          if (persionList[i].userId == this.$store.getters.getUserInfo.userId) {
            persionList[i].disabled = true;
          }
        }
        this.processorsList = persionList;
        if (this.processorsList.length >= 1) {
          this.isPersonData = true;
          return false;
        }
        this.$message({
          type: "error",
          message: "暂无处理人数据"
        });
      } else if (res.code == 101) {
        this.processorsList = [];
      } else {
        this.processorsList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取隐患 负责人
    async getPersonListLogistics() {
      let req = {
        logisticsId: parseInt(this.$store.getters.getUserInfo.logisticsId),
        pageNum: 1,
        pageSize: 999999,
        type: 1,
        userName: ""
      };
      let res = await this.$Http.getPersonLogistics(req, true);
      if (res.code == 200) {
        let persionList = res.data.list;
        for (var i = 0; i < persionList.length; i++) {
          if (persionList[i].userId == this.$store.getters.getUserInfo.userId) {
            persionList[i].disabled = true;
          }
        }
        this.personList = persionList;
        if (this.personList.length >= 1) {
          this.isPersonData = true;
          return false;
        }
        this.$message({
          type: "error",
          message: "暂无负责人数据"
        });
      } else if (res.code == 101) {
        this.personList = [];
      } else {
        this.personList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取隐患 处理人
    async getProcessorsListLogistics() {
      let req = {
        logisticsId: parseInt(this.$store.getters.getUserInfo.logisticsId),
        pageNum: 1,
        pageSize: 999999,
        type: 2,
        userName: ""
      };
      let res = await this.$Http.getPersonLogistics(req, true);
      if (res.code == 200) {
        let persionList = res.data.list;
        for (var i = 0; i < persionList.length; i++) {
          if (persionList[i].userId == this.$store.getters.getUserInfo.userId) {
            persionList[i].disabled = true;
          }
        }
        this.processorsList = persionList;
        if (this.processorsList.length >= 1) {
          this.isPersonData = true;
          return false;
        }
        this.$message({
          type: "info",
          message: "暂无处理人数据"
        });
      } else if (res.code == 101) {
        this.processorsList = [];
      } else {
        this.processorsList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 上报隐患
    async reportHiddenDanger() {
      if (
        this.insertData.principalName == "" ||
        this.insertData.principalName == 0
      ) {
        this.$message({
          type: "info",
          message: "请选择负责人"
        });
      } else {
        var newData = this.insertData;

        let res = await this.$Http.reportHiddenDanger(newData, true);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "上报成功"
          });
          this.temporaryData.personId = "";
          this.cancelForm();
          this.gethiddenDangerData();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "info",
            message: res.messsage
          });
        }
      }
    },
    // 导出隐患
    async exportReport() {
      let schoolId = Number(sessionStorage.getItem("schoolId"));
      let handerDangerIds = this.responseData.list.map((element) => {
        return element.id;
      });
      // console.log(handerDangerIds)
      let handerDangerIdString = "";
      handerDangerIds.map((element) => {
        handerDangerIdString += "&hiddenDangerId=" + element;
      });

      let req = {
        schoolId: schoolId
      };
      this.$Common.exportData(req, "exportReportHiddenDangers", "隐患数据", true);
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.gethiddenDangerData();
    },
    handleChange(val) {
      // console.log(val);
    },
    // 判断是否为小组成员
    async whetherMember() {
      var paramData = {
        userId: this.$store.getters.getUserInfo.userId
      };
      let res = await this.$Http.whetherMember(paramData);
      if (res.code == 200) {
        return true;
      } else {
        return false;
      }
    },
    stateAlter(){
      setTimeout(this.searchIsUnfold = !this.searchIsUnfold, 1000 )
      
    }
  },
  created() {},
  mounted() {
    this.gethiddenDangerData();
  },

  beforeDestroy() {
    if (this.$route.name == "not_done_matter") {
      this.$store.commit("setSelect", true);
      this.$store.commit("updatePathIndex", "1-0");
    }
  }, //生命周期 - 销毁之前
  destroy() {
    console.log("......-----destroy");
  } //生命周期 - 销毁完成
};
</script>
<style lang="scss" scoped>
.el-select,
.el-input {
  width: 170px;
}
.thumbnail {
  img {
    max-height: 2000px;
  }
}
.el-table::before {
  display: none;
}
.arrow-left{
  margin-right: 10px;
}
</style>
